import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Form, FormInstance } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ServerValidationStatus } from '../utils/validationStatusEnum';
import { IGeneralSettingsForm } from './GeneralSettings';
import { ServerConfigurationForm } from './ServerConfigurationForm';

const StyledCard = styled(Card)`
  &&& {
    margin-top: 15px;
  }
  &&& .ant-card-body {
    padding: 0;
    margin: -1px 0 0 -1px;
  }
  &&& .ant-card-grid {
    width: 100%;
    padding: 12px;
  }
`;

export interface IServerConfigurationProps {
  form: FormInstance<IGeneralSettingsForm>;
}

export const ServerConfiguration = ({ form }: IServerConfigurationProps) => {
  const { t } = useTranslation('geosecma-settings');

  const mapSources = (
    <Form.List name="serverInfos">
      {(fields, { add, remove }) => (
        <>
          {fields.map((field) => (
            <ServerConfigurationForm key={`server-${field.key}`} field={field} remove={remove} form={form} />
          ))}
          <StyledCard.Grid hoverable={false}>
            <Button
              data-testid="addSourceButton"
              onClick={() => {
                add({
                  url: '',
                  // key: Math.max(...fields.map((r) => r.fieldKey), -1) + 1,
                  loginType: 'noLogin',
                  username: undefined,
                  password: undefined,
                  token: undefined,
                  validationStatus: ServerValidationStatus.notValidated
                });
              }}
              block
              icon={<PlusOutlined />}
            >
              {t('addSource')}
            </Button>
          </StyledCard.Grid>
        </>
      )}
    </Form.List>
  );

  return (
    <StyledCard title={t('sources')} size="small" type="inner">
      <StyledCard.Grid hoverable={false}>{t('sourcesExplanation')}</StyledCard.Grid>
      {mapSources}
    </StyledCard>
  );
};
